const toFiniteNumber = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

const getProduct = (item = {}) => (
  item.product || item.scheduledProduct?.product || item
);

const getItemId = (item = {}) => {
  const product = getProduct(item);

  return product?.primaryId
    ?? product?._id
    ?? item.scheduledProduct?.primaryId
    ?? item.primaryId
    ?? item._id;
};

export const getRetailCartQuantity = (item = {}) => {
  const quantity = toFiniteNumber(item.quantity);
  return quantity !== null && quantity > 0 ? quantity : 1;
};

export const getRetailCartUnitPrice = (item = {}) => {
  const product = getProduct(item);
  const price = toFiniteNumber(product?.price?.priceAmt);

  if (price !== null) return price;

  const quantity = getRetailCartQuantity(item);
  const cachedTotal = toFiniteNumber(item.totalPrice);
  return cachedTotal !== null ? cachedTotal / quantity : 0;
};

export const calculateRetailCartItemTotal = (item = {}, quantityOverride) => {
  const requestedQuantity = toFiniteNumber(quantityOverride);
  const quantity = requestedQuantity !== null && requestedQuantity > 0
    ? requestedQuantity
    : getRetailCartQuantity(item);
  const total = getRetailCartUnitPrice(item) * quantity;

  return Number.isFinite(total) ? total : 0;
};

export const normalizeRetailCartItem = (item = {}, quantityOverride) => {
  const requestedQuantity = toFiniteNumber(quantityOverride);
  const quantity = requestedQuantity !== null && requestedQuantity > 0
    ? requestedQuantity
    : getRetailCartQuantity(item);

  return {
    ...item,
    quantity,
    totalPrice: calculateRetailCartItemTotal(item, quantity),
  };
};

export const normalizeRetailCartItems = (items = []) => (
  (Array.isArray(items) ? items : []).map((item) => normalizeRetailCartItem(item))
);

export const updateRetailCartQuantity = (items = [], itemId, newQuantity) => (
  (Array.isArray(items) ? items : []).map((item) => (
    normalizeRetailCartItem(
      item,
      getItemId(item) === itemId ? newQuantity : getRetailCartQuantity(item)
    )
  ))
);

export const calculateRetailCartTotal = (items = []) => (
  (Array.isArray(items) ? items : []).reduce(
    (total, item) => total + calculateRetailCartItemTotal(item),
    0
  )
);
